// extracted by mini-css-extract-plugin
export var audioPlayer = "_r8-0";